import React from "react";
import { message } from "antd";
import styles from "./Like.modules.less";
import { LikeFilled, LikeOutlined } from "@ant-design/icons";
import { article } from "@Api";

const { fatchApiV2 } = article;

export interface IProps {
  likeCount: string;
  id: string;
  lsName: string;
  apiUrl: string;
}

interface Istate {
  likeCount: string | number;
  likeStatus: boolean;
}

const info = (msg: string) => {
  message.info(msg);
};

class Like extends React.PureComponent<IProps, Istate> {
  public readonly state = {
    likeCount: 0,
    likeStatus: false,
  };
  public componentDidMount() {
    const { id, lsName, likeCount } = this.props;
    const isLikeComments = localStorage.getItem(lsName) || "";

    this.setState({
      likeCount: likeCount,
      likeStatus: isLikeComments.includes(id),
    });
  }

  public onFavour = () => {
    const { id, apiUrl, lsName } = this.props;
    const { likeCount, likeStatus } = this.state;
    let articleLikeComments: any[] = [];
    if (localStorage.getItem(lsName)) {
      articleLikeComments = JSON.parse(localStorage.getItem(lsName) as string);
    }

    let setTime: any = "";

    clearTimeout(setTime);
    setTime = setTimeout(async () => {
      let isLs = localStorage.getItem(lsName) || "";

      if (likeStatus || isLs.includes(id)) {
        message.error("請不要重複操作哦");
        return false;
      }

      let params = {
        id: id,
      };

      const result: any = await fatchApiV2({
        ...params,
        apiUrl,
      });

      if (result.status == "12000") {
        articleLikeComments.push(id);
        localStorage.setItem(lsName, JSON.stringify(articleLikeComments));

        this.setState({
          likeCount: +likeCount + 1,
          likeStatus: true,
        });
      } else {
        info(result.error.message);
      }
    }, 200);
  };
  public render() {
    const { likeCount, likeStatus } = this.state;

    return (
      <section className={styles["Like"]} onClick={() => this.onFavour()}>
        {!likeStatus ? (
          <LikeOutlined style={{ fontSize: "20px", marginRight: "4px" }} />
        ) : (
          <LikeFilled style={{ fontSize: "20px", color: "#f20", marginRight: "4px" }} />
        )}
        {likeCount == 0 ? "" : likeCount}
      </section>
    );
  }
}

export default Like;
